export class ReportType
{
    public  ReportId : number;
    public ReportName : string;   
   
}